import axios from "axios";
import { TermsDocId, TermsResponse } from "../types/terms";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

export async function fetchTermsVersions(
  id: TermsDocId,
  signal?: AbortSignal
): Promise<TermsResponse> {
  const { data } = await api.get<TermsResponse>(
    `/terms/versions/${id}`,
    signal ? { signal } : undefined
  );
  data.terms.sort((a, b) => b.version - a.version);
  return data;
}

export async function requestAccountDeletion(email: string): Promise<void> {
  await api.post("/account/delete/request", { email });
}

export default api;
